// extracted by mini-css-extract-plugin
export var boxItems = "_70-1";
export var boxItemsLg = "_70-2";
export var button = "_70-7";
export var buttonLg = "_70-8";
export var filterGroupBox = "_70-0";
export var icon = "_70-3";
export var iconSecondary = "_70-6";
export var iconWrapper = "_70-4";
export var iconWrapperLg = "_70-5";